import React, { useState } from 'react';
import styled from 'styled-components';
import { convertFromRaw, EditorState } from 'draft-js';
import RichEditor from '../RichTextEditor/EditorialEditor';
import localization from '../../../config/localization';
import { get } from 'lodash';

const FAQContainer = styled.div`
  margin: 40px 0;
  width: 100%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const FAQTitle = styled.h3`
  color: ${props => props.color || '#000'};
  font-size: ${props => props.fontSize || '24px'};
  margin-bottom: 20px;
  text-align: center;
`;

const AccordionWrapper = styled.div`
  margin-bottom: 10px;
  border-radius: ${props => props.shape === 'rounded' ? '8px' : '0'};
  background-color: ${props => props.backgroundColor || 'rgba(255, 255, 255, 0.4)'};
  overflow: hidden;
`;

const AccordionHeader = styled.div`
  padding: 16px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${props => props.color || '#000'};
  font-weight: 500;
  font-size: 16px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const AccordionContent = styled.div`
  padding: 0 16px 16px;
  color: ${props => props.color || '#000'};
  font-size: 14px;
  line-height: 1.5;
`;

const ExpandIcon = styled.span`
  transition: transform 0.3s ease;
  transform: ${props => props.expanded ? 'rotate(180deg)' : 'rotate(0)'};
  display: inline-block;
  width: 24px;
  height: 24px;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid currentColor;
  }
`;

const FAQ = ({ faqs, preferences }) => {
  const [expanded, setExpanded] = useState(null);

  const handleChange = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  if (!faqs || !faqs.questions || faqs.questions.length === 0) {
    return null;
  }

  return (
    <FAQContainer>
      <FAQTitle 
        color={get(preferences, "description.color", "#000")} 
        fontSize={get(preferences, "description.fontSize", "24px")}
      >
        {faqs.title || 'FAQs'}
      </FAQTitle>
      {faqs.questions.map((question, index) => {
        return (
          <AccordionWrapper
            key={index}
            backgroundColor={get(preferences, "card.color", "rgba(255, 255, 255, 0.4)")}
            shape={get(preferences, "card.shape", "rounded")}
          >
            <AccordionHeader 
              onClick={() => handleChange(index)}
              color={get(preferences, "description.color", "#000")}
            >
              {question.question}
              <ExpandIcon expanded={expanded === index} />
            </AccordionHeader>
            {expanded === index && (
              <AccordionContent color={get(preferences, "description.color", "#000")}>
                {question.answer ? (
                  <RichEditor
                    editorState={EditorState.createWithContent(convertFromRaw(JSON.parse(question.answer)))}
                    readOnly={true}
                    onChange={() => {}}
                  />
                ) : null}
              </AccordionContent>
            )}
          </AccordionWrapper>
        );
      })}
    </FAQContainer>
  );
};

export default FAQ; 